<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown"
    ><i class="ficon" data-feather="bell"></i
    ><span class="badge badge-pill badge-primary badge-up">{{
      unreadCount < 100 ? unreadCount : "99+"
    }}</span></a
  >
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notificaciones</h4>
        <!-- <div class="badge badge-pill badge-light-primary">
          {{
            notifications.messages?.length +
              notifications.systemMessages?.length
          }}
          New
        </div> -->
        <i
          class="action fa-solid fa-arrow-rotate-right"
          (click)="getNotifications()"
        ></i>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar]>
      <a
        class="d-flex"
        href="javascript:void(0)"
        *ngFor="let notification of userNotifications"
      >
        <div class="media d-flex align-items-start">
          <div class="media-body" style="display: flex; flex-flow: column">
            <strong class="media-heading">{{ notification.title }}</strong>
            <span class="notification-text">{{ notification.message }}</span>
            <a
              *ngIf="notification.type === 'file_archive'"
              (click)="goToFileArchive($event)"
              href="/archivos-guardados"
              class="text-primary"
            >
              Ver reporte
            </a>
            <small class="notification-date text-dark">{{
              notification.created_at | relativeDate
            }}</small>
          </div>
        </div>
        <div class="actions">
          <span
            *ngIf="!notification.is_read"
            class="action bg-primary notification-status"
          ></span>
          <i
            (click)="readNotification(notification.id)"
            class="action fa-solid fa-xmark"
          ></i>
        </div>
      </a>
      <!-- <div class="media d-flex align-items-center">
        <h6 class="font-weight-bolder mr-auto mb-0">
          Notificaciones de sistema
        </h6>
        <div class="custom-control custom-control-primary custom-switch">
          <input
            class="custom-control-input"
            id="systemNotification"
            type="checkbox"
            [checked]="system"
          />
          <label class="custom-control-label" for="systemNotification"></label>
        </div>
      </div> -->
      <a
        class="d-flex"
        href="javascript:void(0)"
        *ngFor="let systemNotification of systemNotifications"
      >
        <div class="media d-flex align-items-start">
          <div class="media-left">
            <div
              class="avatar"
              [ngClass]="{
                'bg-light-success':
                  systemNotification.context?.status === 'successful',
                'bg-light-warning':
                  systemNotification.context?.status === 'aborted',
                'bg-light-danger':
                  systemNotification.context?.status === 'failed'
              }"
            >
              <div class="avatar-content">
                <i
                  class="avatar-icon"
                  [data-feather]="
                    systemNotification.context?.status === 'successful'
                      ? 'check'
                      : systemNotification.context?.status === 'aborted'
                      ? 'alert-triangle'
                      : 'x'
                  "
                ></i>
              </div>
            </div>
          </div>
          <div class="media-body" style="display: flex; flex-flow: column">
            <strong class="media-heading">{{
              systemNotification.title
            }}</strong>
            <span class="notification-text">{{
              systemNotification.message
            }}</span>
            <small class="notification-date text-dark">{{
              systemNotification.created_at | relativeDate
            }}</small>
          </div>
        </div>
        <div class="actions">
          <span
            *ngIf="!systemNotification.is_read"
            class="action bg-primary notification-status"
          ></span>
          <i
            *ngIf="!systemNotification.is_read"
            (click)="readNotification(systemNotification.id)"
            class="action fa-solid fa-xmark"
          ></i>
        </div>
      </a>
    </li>
    <!--/ Notifications content -->

    <!-- Notifications footer -->
    <li class="dropdown-menu-footer">
      <a
        [routerLink]="['/perfil/notificaciones']"
        routerLinkActive="router-link-active"
        class="btn btn-primary btn-block"
        href="javascript:void(0)"
        >Ver toda la lista</a
      >
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>
